/* global window */
module.exports = (url, method = 'GET') => {
	return new Promise((resolve, reject) => {
		window.rp_app.request({
			url,
			method,
			dataType: 'json',
			error: (error) => {
				reject(error);
			},
			success: (response/*, status, xhr*/) => {
				resolve(response);
			}
		});
	});
};
